import { secToHMS } from '../../../utils/secToHMS';

/** Parse h:mm:ss, mm:ss, or raw seconds → seconds (Ai-Tempo WorkoutForm parity). */
export function parseTimeToSeconds(value: string | number | null | undefined): number | null {
  if (value === null || value === undefined || value === '') return null;
  const str = String(value).trim();
  if (!str) return null;

  const parts = str.split(':').map(p => p.trim());
  let seconds = 0;

  if (parts.length === 3) {
    const [h, m, s] = parts;
    seconds = (Number(h) || 0) * 3600 + (Number(m) || 0) * 60 + (Number(s) || 0);
  } else if (parts.length === 2) {
    const [m, s] = parts;
    seconds = (Number(m) || 0) * 60 + (Number(s) || 0);
  } else {
    const n = Number(str);
    return Number.isNaN(n) ? null : Math.round(n);
  }

  return Number.isNaN(seconds) ? null : Math.round(seconds);
}

/** Format seconds as h:mm:ss for form inputs. */
export function formatSecondsToFormTime(s: number | null | undefined): string {
  if (s == null || !Number.isFinite(Number(s))) return '';
  return secToHMS(Math.floor(Number(s)));
}

/** Minutes-only input → hh:mm:00 on blur (Ai-Tempo handleBlurTimePlanned). */
export function formatMinutesOnlyInput(raw: string): string | null {
  const trimmed = raw.trim();
  if (!trimmed || !/^\d+$/.test(trimmed)) return null;
  const minutes = parseInt(trimmed, 10);
  if (Number.isNaN(minutes)) return null;
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  const mm = mins.toString().padStart(2, '0');
  return hours === 0 ? `00:${mm}:00` : `${hours}:${mm}:00`;
}

export function strOrEmpty(v: string | number | null | undefined): string {
  if (v === null || v === undefined || v === '') return '';
  return String(v);
}

export function numOrEmpty(v: string | number | null | undefined): string {
  if (v === null || v === undefined || v === '') return '';
  return String(v);
}

/** Optional workout names fall back to the selected sport at save time. */
export function resolveWorkoutTitle(title: string, sportName: string, fallback: string): string {
  return title.trim() || sportName.trim() || fallback;
}
